import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const statusesPageEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-insight-global-configuration-statuses-tab" */ './index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
